// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imageOutput>img[data-v-3447d4a8]{display:block}.imageOutput>div[data-v-3447d4a8]{line-height:100%}", ""]);
// Exports
module.exports = exports;
